import { PRE_PAID } from "../actions/types";

const INITIAL_STATE = {
  cardType: null,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRE_PAID:
      return { ...state, cardType: action.payload };
    default:
      return state;
  }
};

export default reducer;
